// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".detailsSpan[data-v-ebebe1d0] {\n  display: inline-block;\n  margin: 20px 10px;\n  box-sizing: border-box;\n  border-color: transparent;\n  margin: 2px 0 2px 6px;\n  background-color: #f0f2f5;\n  padding: 5px 10px;\n}", ""]);
// Exports
module.exports = exports;
